var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{staticClass:"bg",attrs:{"src":require("../../public/static/img/no-data.png")}}),_c('div',{staticClass:"word"},[_vm._v("暂无数据")]),_c('van-button',{staticClass:"btn",attrs:{"type":"primary"},on:{"click":_vm.toIndex}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }